import React, { useState, useEffect } from 'react';
import { jwtVerify, importSPKI } from 'jose';
import './RedirectHandler.css';

const RedirectHandler = () => {
  const [redirectUrl, setRedirectUrl] = useState('https://app.magalu.com');

  const PUBLIC_KEY_PEM = process.env.REACT_APP_REDIRECT_PUBLIC_KEY?.replace(/\\n/g, '\n');
  useEffect(() => {
    const verifyToken = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');

      if (!token) {
        return;
      }

      try {
        const publicKey = await importSPKI(PUBLIC_KEY_PEM, 'RS256');
        const { payload } = await jwtVerify(token, publicKey);
        if (payload.url) {
          setRedirectUrl(payload.url);
        }
      } catch (err) {
      }
    };

    verifyToken();
  }, [PUBLIC_KEY_PEM]);

  return (
    <div className='app-store-container'>
      <div className="logo"></div>
      <div className="lu">
        <img 
          className="ls-is-cached lazyloaded" 
          width="334" 
          height="642" 
          src="/imagens/5a966dad77d5b2463b12.png" 
          srcSet="/imagens/5a966dad77d5b2463b12.png 1x,
                  /imagens/c89ce6c9010d63acaab3.png 2x,
                  /imagens/94b902d2561b9dde13a8.png 3x" 
          data-srcset="/imagens/5a966dad77d5b2463b12.png 1x,
                       /imagens/c89ce6c9010d63acaab3.png 2x,
                       /imagens/94b902d2561b9dde13a8.png 3x" 
          alt="Lu mostrando o Super App no celular"
        />
      </div>
      <div className="content">
        <h1>Agora é só clicar aqui embaixo e acessar o nosso SuperApp</h1>
        <a 
          className="round-btn icon--ios" 
          href={redirectUrl}
        >
          Abrir no App
        </a>
      </div>
    </div>
  );
};

export default RedirectHandler;
